import { useEffect } from 'react';

import { useConfiguration } from '../providers/configurationProvider/ConfigurationProvider';
import { usePlatformConfigStore } from '../stores/platformConfigStore';

/**
 * Hook to initialize platform configuration store from global configuration.
 * Safe to call from multiple components - initialization only happens once.
 * Can be used by both dashboard and web-sdks apps.
 */
export const usePlatformConfigInitializer = (): void => {
	const { configuration } = useConfiguration();
	const { initialize, isInitialized } = usePlatformConfigStore();

	useEffect(() => {
		if (!configuration?.PLATFORM || isInitialized) {
			return;
		}

		const wfaToggles = configuration?.WFA?.TOGGLES as Record<string, boolean> | undefined;
		initialize(configuration.PLATFORM, wfaToggles);
	}, [configuration, initialize, isInitialized]);
};
